require('./lazyLoadDropdown/lazyLoadDropdownComponent');

const FormDropdownComponent = {
    templateUrl: '/formViewer/component/dropdown/formDropdown.tpl.html',
    controller: 'formDropdownController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umFormViewer')
    .component('uiFormDropdown', FormDropdownComponent);
